import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-test',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './test.html',
  styleUrl: './test.scss',
})
export class Test {}
